module.exports = {
    "tooltipEnabled": "mcaf272ffe_tooltipEnabled",
    "tooltipDisabled": "mcaf272ffe_tooltipDisabled"
};